import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { RepeatSvg } from './Repeat';

export const RepeatIcon = createIcon('repeat', RepeatSvg);
/**
 * @deprecated используйте RepeatIcon
 */
export const withRepeatIcon = withIcon('repeat', RepeatSvg);
